import request from "./../utils/request";

function list(filters, cursor) {
    return request({
        url: `/suppression/list`,
        method: "post",
        data: { filters, cursor },
    });
}

function add(type, value, inbound, outbound, userId) {
    return request({
        url: `/suppression`,
        method: "post",
        data: { type, value, inbound, outbound, userId },
    });
}

function remove(type, value) {
    return request({
        url: `/suppression/remove`,
        method: "post",
        data: { type, value },
    });
}

function update(type, value, inbound, outbound,userId) {
    return request({
        url: `/suppression/update`,
        method: "post",
        data: { type, value, inbound, outbound, userId },
    });
}

export const SUPPRESSION_API = {
    list,
    add,
    remove,
    update,
};
